import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx } from "vue";
const _hoisted_1 = ["aria-live"];
const _hoisted_2 = {
    key: 1,
    class: "rec-dismiss-button"
};
const _hoisted_3 = ["aria-label"];
import { useVModel } from "@vueuse/core";
import { computed, defineAsyncComponent } from "vue";
// Setup
export default /*@__PURE__*/ _defineComponent({
    __name: 'AlertMessage',
    props: {
        dismissible: { type: [Boolean, String], default: false },
        type: { default: "info" },
        icon: { default: "icon-information" },
        size: { default: undefined },
        modelValue: { type: Boolean, default: true }
    },
    emits: ["close", "update:modelValue"],
    setup(__props, { emit: __emit }) {
        const SvgIcon = defineAsyncComponent(() => import("./SvgIcon.vue"));
        // Types & Enums
        const props = __props;
        const emit = __emit;
        const alertClasses = computed(() => {
            return {
                alert: true,
                "alert-info": props.icon !== "icon-information",
                [`alert-${props.type}`]: true,
                [`alert-${props.size}`]: !!props.size,
                "alert-dismissible": !!props.dismissible
            };
        });
        const showMsg = useVModel(props, "modelValue", emit);
        const showIcon = computed(() => props.icon !== "icon-information" || props.type === "info");
        const useDismissibleIcon = computed(() => typeof props.dismissible === "boolean");
        const hide = () => {
            emit("close");
            showMsg.value = false;
        };
        const ariaLive = computed(() => {
            // Critical alerts (danger, warning) interrupt immediately
            // Less urgent alerts (info, success) wait for a pause
            return props.type === "danger" || props.type === "warning" ? "assertive" : "polite";
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Transition, { name: "alert-hide" }, {
                default: _withCtx(() => [
                    (_unref(showMsg))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(alertClasses.value),
                            role: "alert",
                            "aria-live": ariaLive.value,
                            "aria-atomic": "true"
                        }, [
                            (showIcon.value)
                                ? (_openBlock(), _createBlock(_unref(SvgIcon), {
                                    key: 0,
                                    icon: __props.icon,
                                    class: "rc-icon-information"
                                }, null, 8, ["icon"]))
                                : _createCommentVNode("", true),
                            _renderSlot(_ctx.$slots, "default"),
                            (__props.dismissible)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: _normalizeClass(useDismissibleIcon.value ? 'rec-dismiss-button__button' : `btn btn-sm btn-${__props.type}`),
                                        "aria-label": useDismissibleIcon.value ? _ctx.$t('Close alert') : __props.dismissible.toString(),
                                        onClick: hide
                                    }, [
                                        (useDismissibleIcon.value)
                                            ? (_openBlock(), _createBlock(_unref(SvgIcon), {
                                                key: 0,
                                                icon: "icon-close-3"
                                            }))
                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createTextVNode(_toDisplayString(__props.dismissible), 1)
                                            ], 64))
                                    ], 10, _hoisted_3)
                                ]))
                                : _createCommentVNode("", true)
                        ], 10, _hoisted_1))
                        : _createCommentVNode("", true)
                ]),
                _: 3
            }));
        };
    }
});
